import React, { useState, useEffect } from 'react';
import './MainWebsiteLayout.css';
import Header from './Header';
import EventCarousel from './EventCarousel';
import QuickActions from './QuickActions';
import AboutSection from './AboutSection';
import AudienceExperiences from './AudienceExperiences';
import YouTubeVideoCarousel from './YouTubeVideoCarousel';
import TestimonialsSection from './TestimonialsSection';
import PodcastSection from './PodcastSection';
import ReviewBoardSection from './ReviewBoardSection';
import UpcomingEventsCard from './UpcomingEventsCard';
import LatestNews from './LatestNews';
import BecomeMember from './BecomeMember';
import Experiences from './Experiences';
import MediaCoverage from './MediaCoverage';
import { AxiosInstance } from '../../utils';

import "../../../css/bootstrap.min.css";
import "../../../css/animate.min.css";
import "../../../css/style.css";
import "../../../css/responsive.css";
import "../../../css/light-color.css";
import "../../../css/floatlabel.css";
import "../../../css/customstyle.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import MainWebFooter from './mainwebfooter';
const MainWebsitePage: React.FC = () => {
  const [events, setEvents] = useState<any[]>([]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await AxiosInstance.get('/api/getevent?eventstatus=OPEN,REGISTRATIONSCLOSED,REGISTRATIONSOPEN');
        if (response.data.result === 'Success') {
          setEvents(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching events:', error);
      }
    };

    fetchEvents();
  }, []);

  return (
    <div className="main-website-page">
      <Header events={events} />
      <div className="main-website-page-spacer" aria-hidden="true" />
      <main className="main-website-content">
        <section className="left-column" aria-label="Main engagement content">
          <EventCarousel events={events} />
          <YouTubeVideoCarousel
            title="Featured Videos"
            autoPlayInterval={1000000}
            videos={[
              /*{
                url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
                title: 'BSides Bangalore 2026 Highlights',
                description: 'Highlights from BSides Bangalore 2026',
                autoplay: true,
                muted: false,
                loop: true,
              },*/
              {
                url: 'https://www.youtube.com/watch?v=GCEmss7Sm0w',
                title: 'BSides Bangalore 2025 Highlights',
                description: 'Highlights from India’s Premier Cybersecurity Conference',
                autoplay: true,
                muted: false,
                loop: true,
              },
              {
                url: 'https://www.youtube.com/watch?v=Tvb244NMMv4',
                title: 'BSides Bangalore 2024 Highlights',
                description: 'Highlights from BSides Bangalore 2024',
                autoplay: true,
                muted: false,
                loop: true,
              }
            ]}
          />
          <AboutSection />
          <AudienceExperiences />
          <TestimonialsSection />
          <PodcastSection />
          <Experiences />
          <ReviewBoardSection title="Advisory Board" jsonFileName="advisoryboardteam.json" />
          <ReviewBoardSection title="CFP Review Board" jsonFileName="chapteradvisoryboardteam.json" />
          <MediaCoverage title="Media Coverage" />
        </section>
        <aside className="right-column" aria-label="Sidebar Information and Actions">
          <UpcomingEventsCard events={events} />
          <LatestNews />
          <BecomeMember />
        </aside>
        
      </main>
       <MainWebFooter  />
    </div>
  );
};

export default MainWebsitePage;
